export default __webpack_public_path__ + "static/media/live11.094003f7.jpeg";